module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"designation":"Designation","quantity":"Quantity","price":"Price","amount":"Amount","discount":"Discount","VAT":"VAT"},"de":{"designation":"Bezeichnung","quantity":"Anzahl","price":"Preis","amount":"Betrag","discount":"Rabatt","VAT":"MwSt"}}')
  delete Component.options._Ctor
}
